import { BaseText, type BaseTextProps } from "~/components/layout/text/BaseText";

export const ErrorMessage = ({ size = "xs", colour = "danger", children, ...textProps }: BaseTextProps) => {
    return (
        <BaseText {...textProps} size={size} colour={colour}>
            {children}
        </BaseText>
    );
};
